const token = {
  state: {
    token: '',
    version: ''
  },

  mutations: {
    setInfo: (state, info) => {
      state.token = info.token
      if (info.version!= undefined && info.version!=='') {
        state.version = info.version
      }
    }
  }
}

export default token
